import { Container, Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import ButtonYellow from '../../Atoms/ButtonYellow/ButtonYellow';
import { getScreenImage } from '../../../Domain/Utils/ScreenUtilies/ScreenUtilies';
import HeaderModal from '../../Atoms/HeaderModal/HeaderModal';
import { useGetComponentParametersSingle } from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { TYPE_FETCH_PARAMETERS } from '../../../Domain/Settings/Constants/Constants';

// modal component with background

export const SimpleModalLT = (props) => {
  const {
    show,
    title,
    subtitle,
    warning,
    success,
    message,
    closeModal = () => {},
    btnCloseText = 'Cerrar',
    size,
    showFooter = true,
    mayClose = true,
    showTitle = true,
    bgImage = true,
    className = '',
    bodyAlign = true,
    backdrop = 'static'
    // parameters
  } = props;

  const parameters = useGetComponentParametersSingle(
    COMPONENTS.FORM_INTEREST_REGISTER,
    TYPE_FETCH_PARAMETERS.DETAIL
  );

  let { footerContent = null } = props;
  if (footerContent === null) {
    footerContent = (
      <ButtonYellow style={{ width: '40%' }} title={btnCloseText} ifispress={closeModal} />
    );
  }

  const [bgModal, setBgModal] = useState('');

  // Get image file value from parameters API
  useEffect(() => {
    const img = getScreenImage(parameters?.POP_UP);
    window.sessionStorage.setItem('IMG_POP_UP', img);
    setBgModal(img);
  }, [parameters]);

  return (
    <Container>
      <Modal
        show={show}
        className={`p-0 ${className}`}
        onHide={closeModal}
        backdrop={backdrop}
        size={size || ''}
        centered={mayClose ? (props.hiddenHeader ? false : true) : true}>
        <div
          style={{
            borderRadius: '5px',
            backgroundImage: bgImage
              ? `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0,0,0,.3)), url("${bgModal}")`
              : 'none'
          }}>
          {mayClose && props.hiddenHeader ? (
            <Modal.Header className="btn-close-custom" closeButton>
              {showTitle && <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>}
            </Modal.Header>
          ) : (
            <HeaderModal title={title} subtitle={subtitle} warning={warning} success={success} />
          )}
          {message && (
            <Modal.Body
              className={`text-${bodyAlign ? 'center' : 'start'}`}
              style={{ fontWeight: '400' }}>
              {message}
            </Modal.Body>
          )}
          {showFooter && <Modal.Footer style={{ border: 'none' }}>{footerContent}</Modal.Footer>}
        </div>
      </Modal>
    </Container>
  );
};
